// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Відносини з держструктурами» (Government relations, ключ `grm`, група `relationship-management`). */
export const governmentRelationsManifest: IModuleManifest = {
  key: 'grm',
  group: 'relationship-management',
  slug: 'government-relations',
  prefix: 'GRM',
  name: { en: 'Government relations', uk: 'Відносини з держструктурами' },
  entities: [
    { key: 'grm', slug: 'grm', name: { en: 'State bodies', uk: 'Органи влади' }, main: true },
    { key: 'grmrep', slug: 'grmrep', name: { en: 'Representatives', uk: 'Представники' }, main: false },
    { key: 'grmout', slug: 'grmout', name: { en: 'Requests to bodies', uk: 'Наші запити до органів' }, main: false },
    { key: 'grmin', slug: 'grmin', name: { en: 'Requests from bodies', uk: 'Звернення від органів' }, main: false },
  ],
  loadState: () => import('./state/governmentRelationsSlice').then((m) => m.governmentRelationsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
